import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasAlhaurinGrande() {
  return (
    <CityPagePersianas
      name="Alhaurín el Grande"
      slug="alhaurin-el-grande"
      cp="29120"
      poblacion={24500}
      zonaGeo="Guadalhorce"
      lat={36.6438}
      lng={-4.6856}
      zonas={[
        "Centro",
        "El Llano",
        "Villafranco del Guadalhorce",
      ]}
      landmarks={[
        "Plaza Baja",
        "Convento",
        "Sierra de Mijas",
      ]}
      municipiosLimitrofes={[
        "Coín",
        "Mijas",
        "Alhaurín de la Torre",
        "Cártama",
      ]}
      festivalLocal="Feria de San Sebastián, finales de enero"
      contextoTipologico="Pueblo tradicional con expansión residencial, mix casco antiguo y urbanizaciones."
      isCoreZone={false}
    />
  );
}